import {
  FOC_TOUR_LABEL_CMD_IC,
  FOC_TOUR_LABEL_CMD_LEGAL,
  FOC_TOUR_LABEL_CMD_LIAISON,
  FOC_TOUR_LABEL_CMD_PIO,
  FOC_TOUR_LABEL_CMD_SAFETY,
} from '../focTourLabels';
import {
  FOC_CMD_IC_TOUR_STEPS,
  FOC_CMD_LEGAL_TOUR_STEPS,
  FOC_CMD_LIAISON_TOUR_STEPS,
  FOC_CMD_PIO_TOUR_STEPS,
  FOC_CMD_SAFETY_TOUR_STEPS,
  type FocCmdTourStepDef,
} from './focCmdTourSteps';

export const FOC_CMD_IC_TOUR_PARAM = 'focCmdIcTour';
export const FOC_CMD_SAFETY_TOUR_PARAM = 'focCmdSafetyTour';
export const FOC_CMD_LIAISON_TOUR_PARAM = 'focCmdLiaisonTour';
export const FOC_CMD_PIO_TOUR_PARAM = 'focCmdPioTour';
export const FOC_CMD_LEGAL_TOUR_PARAM = 'focCmdLegalTour';

export type FocCmdTourKey = 'ic' | 'safety' | 'liaison' | 'pio' | 'legal';

export type FocCmdTourEntry = {
  key: FocCmdTourKey;
  param: string;
  seatSlug: string;
  hubHref: string;
  label: string;
  steps: FocCmdTourStepDef[];
};

function hubHref(param: string): string {
  return `/hub?${param}=1`;
}

export const FOC_CMD_IC_TOUR_HREF = hubHref(FOC_CMD_IC_TOUR_PARAM);
export const FOC_CMD_SAFETY_TOUR_HREF = hubHref(FOC_CMD_SAFETY_TOUR_PARAM);
export const FOC_CMD_LIAISON_TOUR_HREF = hubHref(FOC_CMD_LIAISON_TOUR_PARAM);
export const FOC_CMD_PIO_TOUR_HREF = hubHref(FOC_CMD_PIO_TOUR_PARAM);
export const FOC_CMD_LEGAL_TOUR_HREF = hubHref(FOC_CMD_LEGAL_TOUR_PARAM);

export const FOC_CMD_TOUR_ENTRIES: readonly FocCmdTourEntry[] = [
  {
    key: 'ic',
    param: FOC_CMD_IC_TOUR_PARAM,
    seatSlug: 'incident-commander',
    hubHref: FOC_CMD_IC_TOUR_HREF,
    label: FOC_TOUR_LABEL_CMD_IC,
    steps: FOC_CMD_IC_TOUR_STEPS,
  },
  {
    key: 'safety',
    param: FOC_CMD_SAFETY_TOUR_PARAM,
    seatSlug: 'safety-officer',
    hubHref: FOC_CMD_SAFETY_TOUR_HREF,
    label: FOC_TOUR_LABEL_CMD_SAFETY,
    steps: FOC_CMD_SAFETY_TOUR_STEPS,
  },
  {
    key: 'liaison',
    param: FOC_CMD_LIAISON_TOUR_PARAM,
    seatSlug: 'liaison-officer',
    hubHref: FOC_CMD_LIAISON_TOUR_HREF,
    label: FOC_TOUR_LABEL_CMD_LIAISON,
    steps: FOC_CMD_LIAISON_TOUR_STEPS,
  },
  {
    key: 'pio',
    param: FOC_CMD_PIO_TOUR_PARAM,
    seatSlug: 'public-information-officer',
    hubHref: FOC_CMD_PIO_TOUR_HREF,
    label: FOC_TOUR_LABEL_CMD_PIO,
    steps: FOC_CMD_PIO_TOUR_STEPS,
  },
  {
    key: 'legal',
    param: FOC_CMD_LEGAL_TOUR_PARAM,
    seatSlug: 'legal-officer',
    hubHref: FOC_CMD_LEGAL_TOUR_HREF,
    label: FOC_TOUR_LABEL_CMD_LEGAL,
    steps: FOC_CMD_LEGAL_TOUR_STEPS,
  },
];

export function focCmdTourSeatHref(
  incidentId: string,
  entry: Pick<FocCmdTourEntry, 'seatSlug' | 'param'>
): string {
  return `/iap/${incidentId}/seat/${entry.seatSlug}?${entry.param}=1`;
}

export function findFocCmdTourEntryByParam(
  searchParams: URLSearchParams
): FocCmdTourEntry | null {
  for (const entry of FOC_CMD_TOUR_ENTRIES) {
    if (searchParams.get(entry.param) === '1') return entry;
  }
  return null;
}

export function findFocCmdTourEntryByKey(
  key: FocCmdTourKey
): FocCmdTourEntry | undefined {
  return FOC_CMD_TOUR_ENTRIES.find((entry) => entry.key === key);
}
